import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaBriefcase, FaComments } from "react-icons/fa";
import PublicHeader from "../../components/PublicHeader";
import PublicFooter from "../../components/PublicFooter";
import { supabase } from "../../supabaseClient";

function formatDate(value) {
  if (!value) return "Not recorded";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "Not recorded" : date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export default function MyApplications({ session, profile }) {
  const [applications, setApplications] = useState([]);
  const [messageCounts, setMessageCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!session?.user?.id) { setLoading(false); return; }
    let active = true;
    async function load() {
      const { data } = await supabase
        .from("dc_applications")
        .select("id, vacancy_id, status, created_at, dc_vacancies(id, title, department, location, closing_date, status)")
        .eq("user_id", session.user.id)
        .order("created_at", { ascending: false });
      if (!active) return;
      const rows = data || [];
      setApplications(rows);
      if (rows.length) {
        const ids = rows.map((item) => item.id);
        const { data: messages } = await supabase.from("dc_application_chat").select("application_id, sender").in("application_id", ids);
        if (!active) return;
        const counts = {};
        (messages || []).forEach((item) => { counts[item.application_id] = (counts[item.application_id] || 0) + 1; });
        setMessageCounts(counts);
      }
      setLoading(false);
    }
    void load();
    return () => { active = false; };
  }, [session?.user?.id]);

  const counts = useMemo(() => ({
    total: applications.length,
    active: applications.filter((item) => ["Received", "Under Review"].includes(item.status)).length,
    accepted: applications.filter((item) => item.status === "Accepted").length,
  }), [applications]);

  return <div className="pguh-public-page-shell">
    <PublicHeader session={session} profile={profile}/>
    <main className="pguh-public-standard-page">
      <div className="nhsuk-width-container pguh-my-applications">
        <Link className="pguh-public-back-link" to="/vacancies"><FaArrowLeft/> Back to vacancies</Link>
        <header className="pguh-my-applications__hero"><div><span className="pguh-eyebrow">Recruitment</span><h1>My applications</h1><p>Review your submitted applications and open conversations started by Management.</p></div><FaBriefcase/></header>
        <section className="pguh-my-applications__summary"><div><span>Total</span><strong>{counts.total}</strong></div><div><span>In progress</span><strong>{counts.active}</strong></div><div><span>Accepted</span><strong>{counts.accepted}</strong></div></section>
        {!session ? <div className="pguh-public-empty"><h2>Sign in required</h2><p>Sign in to view your applications.</p><Link className="nhsuk-button" to="/login">Sign in</Link></div> : loading ? <p>Loading applications…</p> : applications.length === 0 ? <div className="pguh-public-empty"><h2>No applications yet</h2><p>Your submitted vacancies will appear here.</p></div> : <div className="pguh-my-applications__list">{applications.map((application) => {
          const vacancy = application.dc_vacancies || {};
          const messageCount = messageCounts[application.id] || 0;
          return <article key={application.id}><div><span className={`pguh-my-applications__status is-${String(application.status || "received").toLowerCase().replace(/\s+/g,"-")}`}>{application.status || "Received"}</span><h2>{vacancy.title || "Vacancy"}</h2><p>{vacancy.department || "RUHT"}{vacancy.location ? ` · ${vacancy.location}` : ""}</p><small>Submitted {formatDate(application.created_at)}</small></div><div className="pguh-my-applications__messages"><FaComments/><strong>{messageCount}</strong><span>message{messageCount === 1 ? "" : "s"}</span></div><Link className="nhsuk-button nhsuk-button--secondary" to={`/vacancies/${application.vacancy_id}`}>Open application</Link></article>;
        })}</div>}
      </div>
    </main>
    <PublicFooter/>
  </div>;
}
